const imgTeamMotionMainVideo = "./assets/figma/06744399-888e-4094-a77f-3c9a1652fb48.png";
const img2026923382 = "./assets/figma/087e7cd6-d3b1-4396-a41e-5f4578b435b6.png";
const img2026923372 = "./assets/figma/16660b77-d524-4d65-8c96-597e58fa8deb.png";
const img11843 = "./assets/figma/798f6cf7-9cf1-4156-bea0-bd60d4a79b30.png";
const imgRectangle245 = "./assets/figma/0470d51d-5596-4e3f-9712-8c5cae2ec5cf.png";
const imgRectangle252 = "./assets/figma/4991150d-d3e6-4dec-9a8f-d3eb88b6bf59.png";
const imgRectangle253 = "./assets/figma/b92395ad-4207-4437-9626-61de643cb818.png";
const imgRectangle254 = "./assets/figma/5be8b07c-38d7-463d-9d53-5cb4ec23e1b2.png";
const imgRectangle255 = "./assets/figma/536972be-1fdb-4c9a-8b6c-961a2bd36359.png";
const imgRectangle256 = "./assets/figma/4e9a5cb0-1400-4291-a40e-5e63700619b1.png";
const imgRectangle257 = "./assets/figma/2743db58-abbf-4bc7-88f1-568ae7bb87b6.png";
const imgLine21 = "./assets/figma/024cae05-40d5-40cd-8187-3cfbbb55f6fe.svg";
const img1 = "./assets/figma/80ad5ed2-b8f8-4fc7-ae34-3bdb1e3cfeba.svg";
const imgLine25 = "./assets/figma/05a65c31-9eb5-4b95-a7ed-46d18eb9cd91.svg";
const imgLine26 = "./assets/figma/004e04b2-2999-4bf9-a0ef-7d979948c643.svg";
const imgLine27 = "./assets/figma/05a65c31-9eb5-4b95-a7ed-46d18eb9cd91.svg";
const imgRectangle246 = "./assets/figma/5739c19d-a8c6-4a57-b818-fdb5339a6092.svg";
const imgRectangle247 = "./assets/figma/99e09d76-9d1a-40f9-a7b6-5916ffc59faa.svg";
const imgClose = "./assets/figma/174672c4-a815-4d5e-883b-923114b2b971.svg";

export default function TeamMotionMainVideo() {
  return (
    <div className="s0 s1" data-node-id="875:1374" data-name="TEAM_MOTION/MAIN VIDEO">
      <div aria-hidden className="s2 s3 s4">
        <div className="s2 s5 s3" />
        <div className="s2 s3 s6">
          <img alt="" className="s2 s7 s8 s9 s10 s11" src={imgTeamMotionMainVideo} />
        </div>
      </div>
      <div className="s2 s12 s13 s14 s15" data-node-id="875:1376" data-name="image 14" />
      <div className="s2 s16 s17 s18 s19 s20 s21 s22" data-node-id="875:1377">
        <div className="s23 s16 s17 s24 s25 s26 s27 s0 s28 s29 s30" data-node-id="875:1378">
          <p className="s31 s32 s0 s28 s33 s34" data-node-id="875:1379">
            PROJECT OVERVIEW
          </p>
          <div className="s35 s36 s0 s28 s37 s34 s38" data-node-id="875:1380">
            <p className="s39 s40">
              MAIN VIDEO · 1<br aria-hidden />
              MOTION POSTERS · 4
            </p>
            <p className="s39 s40">​</p>
            <p className="s39">​</p>
          </div>
        </div>
        <div className="s17 s41 s18 s42 s0 s28 s43" data-node-id="875:1381">
          <div className="s44 s45">
            <div className="s46 s0 s47">
              <div className="s2 s48">
                <img alt="" className="s49 s9 s1" src={imgLine21} />
              </div>
            </div>
          </div>
        </div>
        <div className="s23 s16 s17 s24 s25 s26 s27 s0 s28 s29 s50" data-node-id="875:1382">
          <p className="s31 s32 s0 s28 s33 s34" data-node-id="875:1383">
            MEMBERS
          </p>
          <p className="s35 s39 s0 s28 s37 s34" data-node-id="875:1384">
            김수영
            <br aria-hidden />
            김지현
            <br aria-hidden />
            장아영
            <br aria-hidden />
            정윤성
          </p>
        </div>
      </div>
      <p className="s23 s2 s51 s32 s52 s27 s29 s33 s53 s54" data-node-id="875:1385">
        LET THE IDEAS ROLL, PLAY THE LAB
      </p>
      <div className="s23 s2 s16 s17 s24 s25 s26 s55 s27 s29 s56 s57" data-node-id="875:1386">
        <p className="s31 s32 s0 s28 s58 s59" data-node-id="875:1387">
          ABOUT
        </p>
        <div className="s35 s36 s0 s28 s37 s59 s38" data-node-id="875:1388">
          <p className="s39 s40">{`모션팀은 가공되지 않은 아이디어가 다양한 AI 도구를 거치며 새로운 결과로 확장되는 과정을 실험실의 구조와 움직임으로 시각화했다. `}</p>
          <p className="s39 s40">{`영상 속 구슬은 아이디어를, 서로 다른 형태와 색의 투명 구조물은 각 AI의 역할과 특성을 상징한다. 딩 실험자가 AI CORE에 구슬을 투입하면 `}</p>
          <p className="s39 s40">{`구슬이 여러 튜브를 빠르게 통과하고, 경로가 나뉘거나 다시 결합되며 탐색·해석·생성의 과정을 보여준다. 가공된 결과는 모니터를 통해 `}</p>
          <p className="s39 s40">{`출력된 뒤 다시 새로운 아이디어로 이어진다. ‘LET THE IDEAS ROLL, PLAY THE LAB’을 중심으로 AI를 직접 연결하고 실험하며 가능성을 `}</p>
          <p className="s39">발견하는 Play Lab의 정체성을 영상 전체의 흐름에 담았다.</p>
        </div>
      </div>
      <p className="s23 s2 s31 s32 s60 s27 s29 s61 s62 s54" data-node-id="875:1389">
        MOTION
      </p>
      <p className="s23 s2 s31 s32 s63 s27 s29 s64 s65 s66" data-node-id="875:1390">
        WORK
      </p>
      <div className="s2 s67 s63 s68" data-node-id="875:1391">
        <div className="s2 s69 s63 s70 s68 s71" data-node-id="875:1392" data-name="이미지 2026. 9. 2. 오후 3.38 2">
          <div className="s2 s3 s6 s4 s70">
            <img alt="" className="s2 s72 s73 s9 s74 s75" src={img2026923382} />
          </div>
        </div>
        <div className="s2 s76 s77 s69 s63 s70 s78 s79 s68 s71" data-node-id="875:1393" />
        <div className="s2 s80 s81 s69 s63 s82 s70 s68 s71" data-node-id="875:1394" />
        <p className="s83 s23 s2 s31 s32 s84 s27 s29 s33 s85 s86 s87" data-node-id="875:1395">
          main video
        </p>
      </div>
      <div className="s2 s67 s88 s68" data-node-id="875:1396">
        <div className="s2 s69 s88 s70 s68 s71" data-node-id="875:1397" data-name="이미지 2026. 9. 2. 오후 3.37 2">
          <div className="s2 s3 s6 s4 s70">
            <img alt="" className="s2 s7 s89 s9 s10 s90" src={img2026923372} />
          </div>
        </div>
        <div className="s2 s76 s77 s69 s91 s70 s92 s79 s68 s71" data-node-id="875:1398" />
        <div className="s2 s80 s81 s69 s93 s82 s70 s68 s71" data-node-id="875:1399" />
        <p className="s83 s23 s2 s31 s94 s95 s27 s29 s33 s85 s86 s96" data-node-id="875:1400">
          IMAge assets
        </p>
      </div>
      <div className="s2 s97 s98 s56 s99" data-node-id="875:1401" data-name="이미지 1184 3">
        <div className="s2 s3 s6 s4">
          <img alt="" className="s2 s7 s100 s9 s10 s101" src={img11843} />
        </div>
      </div>
      <div className="s2 s102 s103 s10 s104" data-node-id="875:1402">
        <img alt="" className="s2 s3 s9 s105 s4 s1" src={imgRectangle245} />
      </div>
      <div className="s106 s2 s16 s17 s18 s19 s107 s108 s109" data-node-id="875:1403" data-name="navigationbar">
        <div className="s16 s17 s110 s26 s0 s28" data-node-id="875:1404">
          <div className="s111 s0 s28 s112" data-node-id="875:1405" data-name="_레이어_1">
            <img alt="" className="s2 s49 s3 s9 s1" src={img1} />
          </div>
          <p className="s23 s31 s113 s32 s27 s0 s28 s29 s114 s115 s116" data-node-id="875:1410">
            DING AI LAB
          </p>
        </div>
        <div className="s16 s17 s117 s18 s0 s28" data-node-id="875:1411">
          <div className="s16 s17 s24 s118 s18 s0 s28 s119" data-node-id="875:1412">
            <p className="s23 s120 s121 s32 s27 s0 s28 s29 s122 s115 s54" data-node-id="875:1413">
              PROJECT
            </p>
            <div className="s46 s0 s28 s34" data-node-id="875:1414">
              <img alt="" className="s2 s49 s3 s9 s1" src={imgLine25} />
            </div>
          </div>
          <div className="s16 s17 s24 s118 s18 s0 s28 s123" data-node-id="875:1415">
            <p className="s23 s120 s121 s32 s27 s0 s28 s29 s122 s115 s54" data-node-id="875:1416">
              TEAM
            </p>
            <div className="s46 s0 s28 s34" data-node-id="875:1417">
              <div className="s2 s48">
                <img alt="" className="s49 s9 s1" src={imgLine26} />
              </div>
            </div>
          </div>
          <div className="s16 s17 s24 s118 s18 s0 s28 s124" data-node-id="875:1418">
            <p className="s23 s120 s121 s32 s27 s0 s28 s29 s122 s115 s54" data-node-id="875:1419">
              ABOUT
            </p>
            <div className="s46 s0 s28 s34" data-node-id="875:1420">
              <img alt="" className="s2 s49 s3 s9 s1" src={imgLine27} />
            </div>
          </div>
        </div>
      </div>
      <div className="s106 s2 s125 s126 s10 s104" data-node-id="875:1477">
        <div className="s2 s127">
          <img alt="" className="s49 s9 s1" src={imgRectangle246} />
        </div>
      </div>
      <div className="s106 s2 s128 s126 s10 s104" data-node-id="875:1478">
        <div className="s2 s129">
          <img alt="" className="s49 s9 s1" src={imgRectangle247} />
        </div>
      </div>
      <div className="s106 s2 s16 s17 s24 s130 s26 s131 s132 s133" data-node-id="875:1481" data-name="PROJECT_CATEGORY_TABS_MOTION">
        <div className="s16 s17 s18 s42 s134 s0 s28 s214" data-node-id="875:1770">
          <p className="s23 s135 s31 s32 s136 s27 s0 s137 s138" data-node-id="856:4229">
            MOTION
          </p>
        </div>
        <div className="s16 s17 s139 s18 s0 s28 s215" data-node-id="856:4230" data-name="PROJECT_CATEGORY_TABS_MOTION">
          <div className="s16 s81 s17 s18 s42 s142 s143 s144 s0 s145 s28" data-node-id="856:4231" data-name="TAB_MAINVIDEO">
            <div aria-hidden className="s2 s152 s3 s4 s145" />
            <p className="s23 s31 s32 s27 s0 s28 s29 s148 s54" data-node-id="856:4232">
              main video
            </p>
            <div className="s2 s3 s4 s150 s151" />
          </div>
          <a className="s16 s141 s17 s18 s42 s142 s143 s144 s0 s145 s146 s28" data-node-id="856:4233" data-name="TAB_IMAGEASSETS">
            <div aria-hidden className="s2 s147 s3 s4 s145" />
            <p className="s23 s31 s32 s27 s0 s28 s148 s149 s138 s54" data-node-id="856:4234">
              image assets
            </p>
            <div className="s2 s3 s4 s150 s151" />
          </a>
        </div>
      </div>
      <div className="s106 s2 s67 s126 s154" data-node-id="875:1489">
        <div className="s2 s5 s216 s153 s156 s157 s154 s158" data-node-id="856:4235" />
        <p className="s23 s2 s31 s32 s217 s27 s29 s160 s161 s54" data-node-id="856:4236">
          main video
        </p>
        <div className="s106 s2 s67 s162 s163" data-node-id="856:4237">
          <div className="s106 s2 s218 s162 s165 s4 s145 s146 s163 s166" data-node-id="856:4238">
            <div aria-hidden className="s2 s147 s3 s145" />
            <div className="s2 s3 s150 s151" />
          </div>
          <div className="s23 s2 s16 s17 s24 s167 s219 s26 s169 s27 s29 s220 s171" data-node-id="856:4239">
            <div className="s16 s17 s24 s172 s26 s0 s28 s34" data-node-id="856:4240">
              <p className="s31 s32 s0 s28 s173 s34" data-node-id="856:4241">
                Prompt
              </p>
              <div className="s35 s36 s0 s28 s174 s34 s38" data-node-id="856:4242">
                <p className="s175 s40">연구실 입구</p>
                <p className="s175 s40">카메라는 정면의 눈높이 시점이며, 화면 중앙에 흰색 연구복과 흰색 바지를 입은 여성 연구원이 뒷모습으로 서 있다. 연구원은 검은 머리를 단정하게 하나로 묶고있고, 오른손에는 작은 야구공보다는 크고 피구공 크기보다는 작은 투명한 유리 구슬공을 자연스럽게 들고 있다. 연구복 등 중앙에는 민트색의 첨부한 이미지의 로고가 인쇄되어 있다. 연구원 앞에는 천장 가까이까지 이어지는 거대한 반투명 자동문이 닫혀 있다. 자동문은 중앙에서 양쪽으로 열리는 구조이며, 두꺼운 라운드 사각형의 프레임 형태이다. 프레임 가장자리에는 밝고 은은한 민트색 LED 라인이 들어가 있다. 문 표면은 화이트의 반투명 유리로 표현하고, 문 뒤쪽의 미래형 연구 장비와 실험실 구조물은 형태만 아주 희미하게 비칠 정도로 부드럽게 블러 처리한다. 자동문 오른쪽에는 민트색 컬러로 Pretendard 서체로 정확하게 “DING AI LAB” 문구를 배치하고, 글자 위와 아래에 짧은 둥근 청록색 바를 하나씩 넣는다. 전체 공간은 창문이 없는 화이트와 민트 계열의 깨끗한 연구실 분위기이며, 밝고 부드러운 확산광과 은은한 바닥 반사를 사용한다. 좌우 대칭에 가까운 정돈된 구도, 넓은 여백으로 부탁한다. 놀이터와 실험실이 결합된 세계관이지만 장식은 과하지 않게 표현한다. 문은 반드시 닫혀있어야하며, 특정 인물을 지칭하는 것 처럼 보이지 않도록하고, 이미지 상에서 누구나 보아도 설득력이 있을 만한 요소들만을 사용하여 생성한다.</p>
                <p className="s175 s40">​</p>
                <p className="s175 s40">연구실 전경</p>
                <p className="s175 s40">STRICT COLOR DISTRIBUTION: White 20% + Blue20% + Pink20%</p>
                <p className="s175 s40">+ Gray20% + Mint20%</p>
                <p className="s175 s40">A single perfectly spherical transparent crystal glass orb centered on a pure #FFFFFF seamless studio background. The sphere must have an extremely smooth, flawless, perfectly polished surface with high transparency, realistic optical refraction, internal light transmission, and a premium crystal-glass appearance.</p>
                <p className="s175 s40">White + Blue + Pink + Gray + Mint must each occupy approximately equal 20% areas.</p>
                <p className="s175 s40">The four colors should appear as large, soft translucent color volumes suspended within the clear glass, smoothly flowing into adjacent areas while remaining visually distinguishable. Allow subtle optical overlap caused only by glass transparency and refraction, but preserve the original White + Blue + Pink + Gray + Mint colors without introducing intermediate or additional hues.</p>
                <p className="s175 s40">keep the colors clean, sort, luminous, and signty translucent rather than opaque.</p>
                <p className="s175 s40">No additional colors anywhere in the sphere.</p>
                <p className="s175 s40">Use a clean premium optical-glass material with a perfectly smooth spherical silhouette. Create a clearly visible transparent</p>
                <p className="s175 s40">outer dacs shell with a siontv micker dass rim suore darker refraction around selected edges, realistic internal refraction, and clean light bending through the sphere.</p>
                <p className="s175 s40">Add large, smooth, controlled specular highlights across the glass surface, includina several soft rectangular studio-liaht reflections along the upper-left and upper portions of the sphere. Add subtle curved highlights following the spherical contour and small concentrated highlights around selected edges. The highlights should ennance the transparent glass appearance without obscuring the internal colors.</p>
                <p className="s175 s40">The glass must look clean, solid, smooth, and optically precise, not liquid or irregular. Keep all reflections broad, polished, controlled, and physically believable.</p>
                <p className="s175 s40">DELICATE ORBITAL NETWORK GRAPHIC</p>
                <p className="s175 s40">Inside and across the transparent glass sphere, add a minimal abstract network composed of ultra-thin white curved lines and circular nodes.</p>
                <p className="s175 s40">Create approximately 3-4 long, elegant orbital paths that curve</p>
                <p className="s175 s40">naturally around the enhard and follow ite thras.dimoncional spherical curvature. The paths should form smooth sweeping arcs rather than straight connections or geometric polygons.</p>
                <p className="s175 s40">Connect selected paths using approximately 5-7 major solid-white circular nodes, combined with approximately 8-12 much smaller white connecting dots. Use noticeably different node sizes to create a clear visual hierarchy: mostly tiny dots, several medium nodes, and only a few larger focal nodes.</p>
                <p className="s175 s40">Keep the network asymmetrical, sparse, airy, and minimal, leaving generous areas of negative space. Do not cover the entire sphere with lines</p>
                <p className="s175 s40">Add a few small transparent glass nodes among the solid-white nodes. These transparent nodes should resemble tiny crystal-glass beads with realistic internal refraction, subtle rim highlights,</p>
                <p className="s175 s40">ano smal specular rerections</p>
                <p className="s175 s40">The network must feel embedded within and wrapped around the transparent glass sphere, rather than printed flat on its surface.</p>
                <p className="s175 s40">{`Allow the sphere's optical properties to naturally affect the network: lines passing deeper inside or behind the sphere should become slightly softer, lighter, and partially refracted, while lines closer to the front remain clean and crisp.`}</p>
                <p className="s175 s40">All network lines must remain extremelv thin smooth. continuous white, and elegant. Use flowing curves only. No sharp corners, no rigid geometric patterns, no tangled lines, and no dense web structures.</p>
                <p className="s175 s40">Beneath the sphere, create a soft, clean glass reflection on a glossy pure-white surface. The reflection should reproduce only</p>
                <p className="s175 s40">{`ine sphere's wnite + Blue + Pink + Gray + Mint tones. Keep the colored reflection slightly stronger and more saturated immediately beneath the contact area, then gradually diffuse and fade outward.`}</p>
                <p className="s175 s40">Add only a minimal soft contact shadow directly beneath the sphere. Do not create a large dark cast shadow.</p>
                <p className="s175 s40">Maintain a completely clean pure #FFFFFF background with no</p>
                <p className="s175 s40">gray gradient, environmental objects, horizon line, or visible studio equipment.</p>
                <p className="s175 s40">High-key professional studio lighting, photorealistic premium product photography, optical crystal glass, crystal-clear</p>
                <p className="s175 s40">Transoarency realistic rav-traced terraction realistic caustics. clean controlled specular reflections, polished glossy finish, minimal tuturistic aestnelic, ultra-nigh resolution, extremely clean</p>
                <p className="s175 s40">Hotaile</p>
                <p className="s175 s40">### Negative Prompt</p>
                <p className="s175 s40">{`> extra colors, color contamination, incorrect color proportions, opaque colors, muddy colors, oversaturated colors, opaque nlastic translucent nastic acrvlic frosted alass cloudy alass milky glass, milky plastic, rough glass, wrinkled glass, wavy glass, rippled surface, bumps, irregular surface distorted sphere uneven silhouette. liaid texture, excessive refraction distortion. bubbles inside the main glass body, scratches, fingerprints, grain, noise, metallic material, chrome, strong black shadow, large dark shadow, gray background, off-white background, colored background, background gradient, complex background, excessive bloom, excessive glow, overexposure, dense network, spider web, tangled`}</p>
                <p className="s175">linoc random carikhloc ctrainht ridir linoc charn analoc polygonal network, circuit board pattern, excessive nodes, excessive lines. thick lines. black lines, colored network lines. text. letters, numbers, symbols, technical diagram, chaotic composition</p>
              </div>
            </div>
            <div className="s16 s17 s24 s172 s26 s0 s28 s34" data-node-id="856:4243">
              <p className="s31 s32 s0 s28 s173 s34" data-node-id="856:4244">
                AI TOOLS
              </p>
              <p className="s35 s175 s0 s28 s174 s34" data-node-id="856:4245">
                Chat GPT, Midjourney, Kling
              </p>
            </div>
          </div>
        </div>
        <div className="s2 s16 s17 s221 s18 s189 s178" data-node-id="875:1487">
          <div className="s222 s0 s28 s223" data-node-id="856:4246">
            <img alt="" className="s2 s49 s3 s9 s1" height="744" src={imgRectangle252} width="939" />
          </div>
          <div className="s16 s17 s24 s224 s26 s0 s28 s225" data-node-id="875:1486">
            <div className="s180 s0 s28 s34" data-node-id="856:4247">
              <img alt="" className="s2 s3 s9 s105 s4 s1" src={imgRectangle253} />
            </div>
            <div className="s180 s0 s28 s34" data-node-id="856:4248">
              <img alt="" className="s2 s3 s9 s105 s4 s1" src={imgRectangle254} />
            </div>
          </div>
        </div>
        <div className="s2 s16 s17 s226 s18 s227 s190" data-node-id="875:1483">
          <div className="s228 s0 s28 s229" data-node-id="856:4253">
            <img alt="" className="s2 s49 s3 s9 s1" height="571" src={imgRectangle255} width="691" />
          </div>
          <div className="s16 s17 s24 s230 s26 s0 s28 s229" data-node-id="875:1482">
            <div className="s201 s0 s28 s34" data-node-id="856:4252">
              <div className="s2 s3 s6 s4">
                <img alt="" className="s2 s231 s103 s9 s232 s34" src={imgRectangle256} />
              </div>
            </div>
            <div className="s201 s0 s28 s34" data-node-id="856:4251">
              <img alt="" className="s2 s3 s9 s105 s4 s1" src={imgRectangle257} />
            </div>
          </div>
        </div>
        <p className="s23 s2 s31 s32 s233 s27 s29 s137 s210 s54" data-node-id="856:4254">
          video stills
        </p>
      </div>
      <button className="s2 s49 s141 s211 s212 s213" data-node-id="891:162" data-name="close">
        <img alt="" className="s2 s49 s3 s9 s1" src={imgClose} />
      </button>
    </div>
  );
}